import { Component, inject, input, InputSignal, signal } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { ListComponent } from '../../../../components/list/list.component';
import { ListItemComponent } from '../../../../components/list/list-item.component';
import { ListItemLabelComponent } from '../../../../components/list/list-item-label.component';
import { OverlayComponent } from '../../../../components/overlay/overlay.component';
import { OverlayHeaderComponent } from '../../../../components/overlay/overlay-header.component';
import { OverlayToggleDirective } from '../../../../components/overlay/overlay-toggle.directive';
import { OverlayAsyncOpenEvent } from '../../../../components/overlay/overlay-factory.service';
import { Account, AccountHelper, RelatedAccount } from '../../../../domain/account.domain';
import { HrefDirective } from '../../../../directives/href/href.directive';
import { AccountLabelComponent } from '../../account-selector/account-label.component';
import { AccountsContainer } from '../../services/accounts-container';
import { AccountsRestService } from '../../services/accounts-rest.service';
import { NumberPipe } from '../../../../pipes/number.pipe';

@Component({
  selector: 'td-wb-dividends-related-accounts',
  templateUrl: './dividends-related-accounts.component.html',
  styleUrls: ['./dividends-related-accounts.component.scss'],
  imports: [
    TranslateDirective,
    OverlayComponent,
    OverlayHeaderComponent,
    OverlayToggleDirective,
    ListComponent,
    ListItemComponent,
    ListItemLabelComponent,
    HrefDirective,
    AccountLabelComponent,
    NumberPipe
  ]
})
export class DividendsRelatedAccountsComponent {
  private readonly accountsRestService: AccountsRestService = inject(AccountsRestService);

  readonly symbolName = input.required<string>();
  readonly relatedAccounts: InputSignal<Array<RelatedAccount>> = input.required<Array<RelatedAccount>>();
  protected readonly accounts = signal<Array<Account> | undefined>(undefined);
  protected readonly placeholder: string = '\u2014';

  protected onAccountsOverlayOpen(event: OverlayAsyncOpenEvent): void {
    lastValueFrom(this.accountsRestService.getAccounts())
      .then((accountsContainer: AccountsContainer): void => {
        const accounts: Array<Account> = [];
        this.relatedAccounts().forEach((relatedAccount: RelatedAccount): void => {
          const account = accountsContainer.get(relatedAccount.accountId);
          if (account !== undefined) {
            accounts.push(account);
          }
        });
        this.accounts.set(accounts);
        event.open();
      });
  }

  protected trackByAccount(_: number, account: Account): string {
    return account.id;
  }

  protected isDIAccount(account: Account): boolean {
    return AccountHelper.isDIAccount(account);
  }
}
